import { Link, useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus } from "lucide-react";
import { useBasket } from "../context/BasketContext";
import { useAuth } from "../context/AuthContext";
import { gbp } from "../lib/api";

export default function BasketPage() {
  const { items, updateQty, remove, subtotal } = useBasket();
  const { isMember } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-12">
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-10">YOUR <span className="text-[#FFCC00]">BASKET</span></h1>
      {items.length === 0 ? (
        <div className="border border-[#27272A] p-16 text-center">
          <div className="font-display text-3xl text-white/30 mb-6">NOTHING HERE YET.</div>
          <Link to="/deals" data-testid="basket-browse-deals-link" className="btn-industrial px-8 py-3 text-lg inline-block">BROWSE TODAY'S DEALS</Link>
        </div>
      ) : (
        <div className="grid lg:grid-cols-[1fr_320px] gap-10">
          <div className="space-y-px bg-[#27272A] border border-[#27272A]">
            {items.map((i) => (
              <div key={i.deal_id} data-testid={`basket-item-${i.slug}`} className="bg-[#0A0A0A] p-5 flex gap-5 items-center">
                <img src={i.image} alt={i.title} className="w-20 h-20 object-cover grayscale" />
                <div className="flex-1 min-w-0">
                  <div className="text-[10px] uppercase tracking-widest text-white/40">{i.sku}</div>
                  <Link to={`/deal/${i.slug}`} className="font-display text-lg leading-tight hover:text-[#FFCC00] block truncate">{i.title}</Link>
                  <div className="text-[#FFCC00] text-sm mt-1">{gbp(i.price)} / lot</div>
                </div>
                <div className="flex border border-[#27272A]">
                  <button data-testid={`basket-qty-dec-${i.slug}`} onClick={() => updateQty(i.deal_id, i.qty - 1)} className="px-2.5 hover:bg-[#1A1A1A]"><Minus size={12} /></button>
                  <span className="px-4 py-2 text-sm border-x border-[#27272A]">{i.qty}</span>
                  <button data-testid={`basket-qty-inc-${i.slug}`} onClick={() => updateQty(i.deal_id, i.qty + 1)} className="px-2.5 hover:bg-[#1A1A1A]"><Plus size={12} /></button>
                </div>
                <button data-testid={`basket-remove-${i.slug}`} onClick={() => remove(i.deal_id)} className="text-white/40 hover:text-[#FF3B30] p-2"><Trash2 size={16} /></button>
              </div>
            ))}
          </div>
          <div className="border border-[#27272A] p-8 h-fit">
            <h3 className="font-display text-2xl mb-6">SUMMARY</h3>
            <div className="flex justify-between text-sm mb-2"><span className="text-white/50">Subtotal</span><span data-testid="basket-subtotal">{gbp(subtotal)}</span></div>
            <div className="flex justify-between text-sm mb-6"><span className="text-white/50">Delivery</span><span className="text-white/50">Calculated at checkout</span></div>
            <button
              data-testid="basket-checkout-button"
              onClick={() => navigate(isMember ? "/checkout" : "/join")}
              className="btn-industrial w-full py-4 text-xl"
            >
              {isMember ? "CHECKOUT" : "JOIN FREE TO CHECKOUT"}
            </button>
            <p className="text-white/30 text-[11px] mt-4">Pay by bank transfer with your unique payment reference. Stock is reserved once your order is placed.</p>
          </div>
        </div>
      )}
    </div>
  );
}
